/* MV Design - 17 de agosto de 2026
   ------------------------------------------------------------------
   PROBLEMA
   Shopify migro las imagenes de producto de /cdn/shop/products/ a
   /cdn/shop/files/. El script de SCA Quick View (assets/sca-qv-scripts-
   noconfig.js, incrustado en el tema desde 2018) solo engancha tarjetas
   cuya imagen lleve "/products/" en la URL:

     .has('img[src*="/products/"], img[src*="/no-image"],
           img[data-srcset*="/products/"]')

   Resultado: todo producto subido de un tiempo para aca nace sin boton
   de Quick View. Al 17 de agosto de 2026 afectaba a Canasta de Doce y
   Canasta Doble Tamarindo, y afectaria a todos los productos futuros.

   SOLUCION
   Agregar un <img> senuelo, oculto y sin descarga, dentro del enlace de
   producto, con un data-srcset que contiene "/products/". Asi el selector
   original lo reconoce sin que toquemos ninguna imagen real. El senuelo
   no tiene src ni clase de lazysizes, asi que no genera ninguna peticion.

   POR QUE ASI Y NO INYECTANDO EL BOTON A MANO
   La app enlaza el clic con fancybox de forma DIRECTA, no delegada
   ($(".sca-qv-button").scafancybox({...})), y el hover tambien
   ($(".sca-qv-image").hover(...)). Un boton inyectado despues de su
   inicializacion quedaria sin estilo, sin hover y sin abrir el modal.
   Corriendo antes que la app, su flujo nativo hace todo el trabajo.

   POR QUE HAY MARGEN DE SOBRA
   La app carga su propia jQuery 1.11.1 desde googleapis de forma asincrona
   y recien despues registra su jQuery191(document).ready(...). Nuestro
   parche corre en DOMContentLoaded, que siempre ocurre antes. Aun asi se
   repite unas veces por seguridad, y es idempotente.

   Se carga desde snippets/sca-quick-view-init.liquid.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var SELECTOR_OK = 'img[src*="/products/"], img[src*="/no-image"], img[data-srcset*="/products/"]';
  var SELECTOR_FILES = 'img[src*="/files/"], img[data-srcset*="/files/"]';
  var total = 0;

  function parchar() {
    var enlaces, i, a, senuelo, n = 0;
    try {
      enlaces = document.querySelectorAll('a[href*="/products/"]');
    } catch (e) {
      return 0;
    }
    for (i = 0; i < enlaces.length; i++) {
      a = enlaces[i];
      if (a.getAttribute('data-mv-qv-fix')) continue;
      if (a.querySelector(SELECTOR_OK)) continue;
      if (!a.querySelector(SELECTOR_FILES)) continue;

      senuelo = document.createElement('img');
      senuelo.className = 'mv-qv-decoy';
      senuelo.setAttribute('data-srcset', '/products/');
      senuelo.setAttribute('alt', '');
      senuelo.setAttribute('aria-hidden', 'true');
      senuelo.style.display = 'none';
      a.appendChild(senuelo);

      a.setAttribute('data-mv-qv-fix', '1');
      n++;
    }
    total += n;
    if (n > 0 && window.console && console.log) {
      console.log('[mv-qv-files-fix] tarjetas corregidas: ' + n + ' (total ' + total + ')');
    }
    return n;
  }

  window.mvQvFilesFix = parchar;

  parchar();

  function arrancar() {
    parchar();
    setTimeout(parchar, 300);
    setTimeout(parchar, 1200);
    setTimeout(parchar, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
